import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Dialog,
  DialogTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { getConfirmedRoutes } from "src/utils/GetPlanning";


interface Inputs {
  open: any;
  onClose: any;
  onSelection: any;
  routeList: any;
  selectedRoute:any;
  currentRoute:any;
  multipleRoutes:any;
  toggleRoute:any
}

export default function Route(props: Inputs) {

  const useStyles = makeStyles((theme: Theme) => ({
    button: {
      margin: theme.spacing(2),
    }
  }));

  const classes = useStyles();

  const [confirmRoutes, setConfirmRoutes] = useState([]);
  const [salesOrg_cur,customerNumber_cur,planningDateStr_cur]=props?.currentRoute;
  const [sales_org_mul,planningDate_mul,routePopup]=props?.multipleRoutes;
  const route=props?.toggleRoute;

  useEffect(()=>{
    if (routePopup===true||route>-1) {
      const delivering_plant=props?.routeList[0]?.deliveringPlant;
      var SALES_ORG_VALUE=(salesOrg_cur!==undefined)?salesOrg_cur:sales_org_mul;
      var PLANNING_DATE_VALUE=(planningDateStr_cur!==undefined)?planningDateStr_cur:planningDate_mul;
      getConfirmedRoutes(SALES_ORG_VALUE, customerNumber_cur,PLANNING_DATE_VALUE,delivering_plant).then((v: any) => {
     // console.log("getConfirmedRoutes ", v);
      if (v) {
        setConfirmRoutes(v)
      }
      });
    }
  },[route,routePopup])

  if (props.open === false) {
    return null;
  }

  const checkDisable=(selectedRoute:any,currentRoute:any,confirmRoutes:any):boolean=>{

    if (selectedRoute===currentRoute) {
      return true;
    }
    else{
      for(let i=0;i<confirmRoutes.length;i++){
       // console.log('currentRoute===confirmRoutes[i]?.route_act :>> ', currentRoute,confirmRoutes[i]?.route_act,currentRoute===confirmRoutes[i]?.route_act);
        // return currentRoute===confirmRoutes[i]?.route_act?true:false;
        if (currentRoute===confirmRoutes[i]?.route_act) {
          return true;
        }
      }
    }
    return false;
  }

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      aria-labelledby="dri-title"
      open={props.open}
      onClose={props.onClose}
    >
      <DialogTitle id="dri-title">Change Route</DialogTitle>
        {props.routeList.map((item: any, index: number) => {
          const routeName = item.route;
          return (
            <Button variant="outlined"
            className={classes.button}
            disabled={checkDisable(props.selectedRoute,routeName,confirmRoutes)}
            disableElevation
            onClick={() => props.onSelection(routeName)}>{routeName}</Button>
          );
        })}


        <Button variant="outlined"
                className={classes.button}
                style={{color: "grey"}}
                disableElevation
                onClick={() => props.onSelection("")}>Abort</Button>
    </Dialog>
  );
}
